module.exports =
  template: require('./index.pug')()
  bindings:
    service: '<'
    serviceAddon: '<'
    onSubmit: '&'
    onBack: '&'
